"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _DealStage = _interopRequireDefault(require("./DealStage"));

var _immutable = require("immutable");

var DealPipeline = (0, _immutable.Record)({
  active: true,
  displayOrder: -1,
  label: '',
  pipelineId: undefined,
  stages: (0, _immutable.List)(),
  staticDefault: false
}, 'DealPipeline');

DealPipeline.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  return DealPipeline((0, _extends2.default)({}, json, {
    stages: json.stages ? (0, _immutable.List)(json.stages.map(_DealStage.default.fromJS)) : (0, _immutable.List)()
  }));
};

var _default = DealPipeline;
exports.default = _default;
module.exports = exports.default;